import { ToastrService } from 'ngx-toastr';
import {
  ViewWorkDataModel,
  ViewWorkDataQuestion,
  ViewWorkDataVM,
  QuestionTypeRedirectEnum,
  ViewWorkTemplateType,
  ViewWorkRTIType,
  ViewWorkConsumerCurriculumRTIType,
  ViewWorkConsumerCurriculumTemplateType,
} from './../../../Elearning-Models';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IAPIService } from 'src/app/Services/API-Service/IAPIService';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../shared/confirm-dialog/confirm-dialog.component';
import {Location} from '@angular/common';
import { FilterQuestionsService } from 'src/app/Services/filter-questions.service';

@Component({
  selector: 'app-view-work-page',
  templateUrl: './view-work-page.component.html',
  styleUrls: ['./view-work-page.component.scss'],
})
export class ViewWorkPageComponent implements OnInit {
  workDataReceived: boolean = false;
  studentWorkData: ViewWorkDataVM;
  assignmentName: string;
  studentName: string;
  submitInProgress: boolean = false;

  isConsumerCurriculum: boolean = true;

  gradeChangedObject: {} = {};

  constructor(
    private activatedRoute: ActivatedRoute,
    private APIService: IAPIService,
    private dialog: MatDialog,
    private toastr: ToastrService,
    private location: Location,
    private filterQuestionsService: FilterQuestionsService
  ) {}

  ngOnInit(): void {
    this.activatedRoute.queryParamMap.subscribe((queryParams) => {
      const AssignmentID = +queryParams.get('AssignmentID');
      const AttemptID = +queryParams.get('AttemptID');
      this.assignmentName = queryParams.get('AssignmentName');
      this.studentName = queryParams.get('StudentName');
      if (AssignmentID && AttemptID) {
        this.getViewWorkData({
          AssignmentID,
          AttemptID,
        });
      }
    });
  }

  getViewWorkData = (viewWorkData: ViewWorkDataModel) => {
    this.workDataReceived = false;
    this.APIService.GetViewWorkData(viewWorkData).subscribe(
      (response: ViewWorkDataVM) => {
        this.studentWorkData = response;
        this.redirectToOldPage();
        this.sortQuestions();

        //if this is consumer curriculum user, we need to disable clicking...
        this.APIService.IsConsumerCurriculum().subscribe(result => {
           this.isConsumerCurriculum = result;
           this.workDataReceived = true;
        });
      }
    );
  };

  redirectToOldPage = () => {
    var i = this.studentWorkData.Questions.findIndex(q => Object.values(QuestionTypeRedirectEnum).includes(q.QuestionTypeEnumValue));
    if(i != -1){
      window.location.assign('/LearningContent/ViewStudentResults.aspx?AttemptID='
       + this.studentWorkData.AttemptID);
    }
  }

  sortQuestions = () => {
    let prevCategoryType = 0;
    this.studentWorkData.Questions.sort(
      (a, b) => a.SequenceNumber - b.SequenceNumber
    );
    var tempList = this.studentWorkData.Questions;

      this.studentWorkData.Questions
      .forEach(q => 
        { // grab the category for each and put in a dummy question with just the category name
          if(q.RTIModuleType){
            if(q.RTIModuleType != prevCategoryType){
              prevCategoryType = q.RTIModuleType;
              var categoryQ = new ViewWorkDataQuestion();
              categoryQ.QuestionText = ViewWorkRTIType[q.RTIModuleType];
              categoryQ.SequenceNumber = q.SequenceNumber - .5;
              if(this.isConsumerCurriculum && !ViewWorkConsumerCurriculumRTIType[categoryQ.QuestionText]){
                categoryQ.HideFromConsumerCurriculum = true;
              }
              tempList.push(categoryQ);
            }
          }
          else if(q.TemplateComponentType){
            if(q.TemplateComponentType != prevCategoryType){
              prevCategoryType = q.TemplateComponentType;
              var categoryQ = new ViewWorkDataQuestion();
              categoryQ.QuestionText = ViewWorkTemplateType[q.TemplateComponentType];
              categoryQ.SequenceNumber = q.SequenceNumber - .5;
              if(this.isConsumerCurriculum && !ViewWorkConsumerCurriculumTemplateType[categoryQ.QuestionText]){
                categoryQ.HideFromConsumerCurriculum = true;
              }
              tempList.push(categoryQ);
            }
        }
      });

      this.studentWorkData.Questions = tempList.sort(
        (a, b) => a.SequenceNumber - b.SequenceNumber
      );
  };

  gradeChanged = (question: ViewWorkDataQuestion) => {
    this.gradeChangedObject[question.LessonItemID] = {LessonItemID: question.LessonItemID, PointsEarned: question.PointsEarned};
  }

  getSubmitObject = () => {
    let questionsArray = [];
    Object.values(this.gradeChangedObject).map(question => questionsArray.push(question));
    return {
      StudentID: this.studentWorkData.StudentID,
      AttemptID: this.studentWorkData.AttemptID,
      Questions: questionsArray
    }
  }

  onSubmit = () => {
    this.submitInProgress = true;
    this.APIService.SubmitViewWorkData(this.getSubmitObject()).subscribe(response => {
      this.submitInProgress = false;
      if(response.Success) {
        this.gradeChangedObject = {};
        if(response.Graded) {
          this.location.back();
          this.toastr.success('Student Grade Saved', 'Success!');
        } else {
          this.toastr.success('Student Grade Saved', 'Success!');
          this.openConfirmDialog('Grade Successfully Updated', 'Do you want to finish the Grading now or later');
        }
      } else {
        this.toastr.error('Something went wrong', 'Failure!');
      }
    })
  }

  openConfirmDialog = (title: string, text: string) => {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title,
        text,
        cancelBtn: 'Stay',
        confirmBtn: 'Leave'
      },
      autoFocus: false,
    });

    const sub = dialogRef.componentInstance.confirmSelected.subscribe(
      (confirmSelected) => {
        this.location.back();
      }
    );

    dialogRef.afterClosed().subscribe((result) => {
      this.filterQuestionsService.setFilterValue('ungraded');
      sub.unsubscribe();
    });
  }

  
  back(){
    this.location.back();
  }

}
